.formContainer {
  padding: 0.75rem 0.75rem 0.5rem 0.75rem;
  border: 0.2rem solid #e0e0e0;
  background-color: #f5f5f5;
}

.formGroup {
  margin-bottom: 0.75rem;
}

.formRow {
  display: flex;
  gap: 1rem;
  margin-bottom: 0.75rem;
  flex-wrap: wrap;
}

.formRow .formGroup {
  flex: 1;
  min-width: 0;
  margin-bottom: 0;
}

.formLabel {
  display: block;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #333;
}

.formInput {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  font-family: inherit;
}

.formInput:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
}

.formInput[disabled] {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.selectInput {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  font-family: inherit;
  background-color: white;
}

.selectInput:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
}

.buttonContainer {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 0.75rem;
}

.narrowField {
  max-width: 300px;
}
